import { Component } from '@angular/core';
import { ClientTaskHistoryItemTypeBaseComponent } from '../client-task-history-item-type-base/client-task-history-item-type-base.component';
import { ClientTaskHistoryItemTitleComponent } from '../client-task-history-item-title/client-task-history-item-title.component';
import { ClientTaskHistoryItemBodyComponent } from '../client-task-history-item-body/client-task-history-item-body.component';
import { TitleCasePipe } from '@angular/common';

@Component({
    selector: 'app-client-task-history-item-type-transitioned',
    templateUrl: './client-task-history-item-type-transitioned.component.html',
    imports: [ClientTaskHistoryItemTitleComponent, ClientTaskHistoryItemBodyComponent, TitleCasePipe]
})
export class ClientTaskHistoryItemTypeTransitionedComponent extends ClientTaskHistoryItemTypeBaseComponent {
  get status() {
    return this.clientTaskHistoryItem.data.status;
  }
}
